import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
export function FinalCTA() {
  const features = ['Acceso inmediato', 'Descarga digital', 'Compatible con celular y PC', 'Actualizaciones incluidas', 'Pago seguro'];
  return <section className="bg-white py-10 md:py-14" data-id="element-45">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-46">
        <div className="inline-flex items-center justify-center w-14 h-14 bg-forest/10 rounded-full mb-5" data-id="element-47">
          <ShieldCheckIcon className="w-7 h-7 text-forest" data-id="element-48" />
        </div>

        <h2 className="font-serif text-3xl md:text-5xl font-bold text-ink mb-5 leading-tight" data-id="element-49">
          Tu mascota depende de las decisiones que tomes hoy
        </h2>

        <p className="text-lg text-gray-600 mb-8" data-id="element-50">
          Cada comida es una oportunidad para mejorar su salud y bienestar.
        </p>

        <div className="flex items-baseline justify-center gap-3 mb-8" data-id="element-51">
          <span className="text-gray-400 line-through text-xl" data-id="element-52">$50.000</span>
          <span className="text-5xl md:text-6xl font-bold text-forest" data-id="element-53">
            $19.990
          </span>
        </div>

        <a href="https://impulsodigital.vip/cart/44794622902358:1" className="inline-block bg-forest text-white px-12 py-5 rounded-lg text-lg font-bold hover:bg-forest/90 transition-colors shadow-lg mb-8" data-id="element-54">
          QUIERO ACCESO YA
        </a>

        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 text-sm" data-id="element-55">
          {features.map((feature, index) => <div key={index} className="flex items-center justify-center gap-1.5" data-id="element-56">
              <CheckIcon className="w-4 h-4 text-forest flex-shrink-0" data-id="element-57" />
              <span className="text-gray-700" data-id="element-58">{feature}</span>
            </div>)}
        </div>

        <p className="text-xs text-gray-500 mt-8" data-id="element-59">
          Garantía de satisfacción de 7 días
        </p>
      </div>
    </section>;
}